import { createError } from '@adv-frontend/error';
import { isObject } from '@direct-frontend/stdlib';

/** Ошибка, которая происходит если попытаться обновить значение поля по некорректному пути */
export const FormInvalidFieldValueSettingError = createError<{ fieldPath: string[] }>('FormInvalidFieldValueSetting');

/**
 * Устанавливает значение поля в форме по заданному пути
 * @param formValue Текущее значение всех полей формы
 * @param fieldPath Путь до поля
 * @param fieldValue Новое значение поля
 * @returns Новое значение всех полей формы
 */
export function setFieldValueAtPath<FormValue extends object>(
    formValue: FormValue,
    fieldPath: string[],
    fieldValue: unknown
): FormValue {
    const fieldPathArray = [...fieldPath];

    function set(parent?: unknown): unknown {
        // Если путь до поля пуст, то возвращаем нужное значение, чтобы установить его в объект
        if (fieldPathArray.length === 0) {
            return fieldValue;
        }

        const key = fieldPathArray.shift();

        if (typeof key === 'string') {
            if (isObject(parent)) {
                return {
                    ...parent,
                    [key]: set(parent[key]),
                };
            }

            if (Array.isArray(parent)) {
                const index = parseInt(key);

                return [...parent.slice(0, index), set(parent[index]), ...parent.slice(index + 1)];
            }

            // Если значение не является объектом, то мы пытаемся установить вложенное значение в примитивное поле
            throw new FormInvalidFieldValueSettingError('Invalid form field value setting', {
                cause: null,
                additional: { fieldPath },
            });
        }

        return parent;
    }

    // Кастим вручную, так как `set` возвращает `unknown`, потому что работает с любым вложенным в `formValue` значением
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- см. выше
    return set(formValue) as FormValue;
}
